import { render, staticRenderFns } from "./contact-us.vue?vue&type=template&id=89a28a88&"
import script from "./contact-us.vue?vue&type=script&lang=js&"
export * from "./contact-us.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports